module.exports = __webpack_public_path__ + "img/booking-online.2eae3945.svg";